import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Snapshot } from '../../shared/interfaces/snapshot.interface';

export interface ViewSnapshotDescriptionModalData {
  snapshot: Snapshot;
}

export interface ViewSnapshotDescriptionModalResult {
  action: 'close';
}

@Component({
  selector: 'app-view-snapshot-description-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './view-snapshot-description-modal.component.html',
  styleUrls: ['./view-snapshot-description-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSnapshotDescriptionModalComponent {
  private dialogRef = inject<MatDialogRef<ViewSnapshotDescriptionModalComponent>>(MatDialogRef);
  data = inject<ViewSnapshotDescriptionModalData>(MAT_DIALOG_DATA);


  onClose() {
    this.dialogRef.close({
      action: 'close'
    } as ViewSnapshotDescriptionModalResult);
  }
} 